import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatusInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const status = req.params.get('status');
    if (status === 'true' || status === 'false') {
      req = req.clone({
        params: req.params.set('status', status === 'true' ? '1' : '0')
      });
    }
    return next.handle(req);
  }
}
